import { ActionType } from 'typesafe-actions';
import merge from 'lodash/merge';

import * as Actions from './actions';
import * as Constants from './constants';
import * as Types from './types';

const initialState: Types.IState = {
  entities: {},
  list: {
    ids: [],
    isFetched: false,
    isLoaded: false
  },
  single: {
    id: 0,
    isFetched: false
  }
};

export default (state: Types.IState = initialState, action: ActionType<typeof Actions>): Types.IState => {
  switch (action.type) {
    case Constants.ENTITIES: {
      const { items } = action.payload;
      return {
        ...state,
        entities: merge({}, state.entities, items)
      };
    }
    case Constants.LIST.REQUEST: {
      const list = state.list || {};

      return {
        ...state,
        list: {
          ...state.list,
          ids: list.ids || [],
          isFetched: false,
          isLoaded: !!list.isLoaded
        }
      };
    }
    case Constants.LIST.SUCCESS: {
      const { ids } = action.payload;
      return {
        ...state,
        list: {
          ...state.list,
          ids,
          isFetched: true,
          isLoaded: true
        }
      };
    }
    case Constants.LIST.FAILURE: {
      return {
        ...state,
        list: {
          ...state.list,
          isFetched: true,
          isLoaded: true
        }
      };
    }
    case Constants.SINGLE.REQUEST: {
      return {
        ...state,
        single: {
          ...state.single,
          isFetched: false
        }
      };
    }
    case Constants.SINGLE.SUCCESS: {
      const { id } = action.payload;
      return {
        ...state,
        single: {
          ...state.single,
          id,
          isFetched: true
        }
      };
    }
    case Constants.SINGLE.FAILURE: {
      return {
        ...state,
        single: {
          ...state.single,
          isFetched: true
        }
      };
    }
    default:
      return state;
  }
}